export const MAX_KEY_FAILURE_THRESHOLD_V95 = 1000;

export const normalizeChannelKeyPolicyV95 = (config = {}) => ({
  ...config,
  disable_key_on_failure: config.disable_key_on_failure !== false,
  key_failure_threshold_v95: config.key_failure_threshold_v95 ?? 1,
});

export const preserveKeyPolicyOnRevealV95 = (current, revealed) => ({
  ...revealed,
  disable_key_on_failure: current.disable_key_on_failure !== false,
  key_failure_threshold_v95: current.key_failure_threshold_v95 ?? 1,
  ...(current.key_usage_strategy_v95 !== undefined
    ? { key_usage_strategy_v95: current.key_usage_strategy_v95 }
    : {}),
  ...(current.coding_plan_cooldown_hours_v95 !== undefined
    ? { coding_plan_cooldown_hours_v95: current.coding_plan_cooldown_hours_v95 }
    : {}),
});

export const buildChannelKeyPolicyV95 = (config = {}) => {
  const result = normalizeChannelKeyPolicyV95(config);
  const raw = result.key_failure_threshold_v95;
  const threshold = typeof raw === 'number' ? raw : Number(String(raw).trim());
  if (
    !['number', 'string'].includes(typeof raw) ||
    !Number.isInteger(threshold) ||
    threshold < 1 ||
    threshold > MAX_KEY_FAILURE_THRESHOLD_V95
  ) {
    if (result.disable_key_on_failure === false) {
      result.key_failure_threshold_v95 = 1;
      return result;
    }
    throw new Error('channel.edit.key_failure_policy.invalid_threshold_v95');
  }
  result.key_failure_threshold_v95 = threshold;
  return result;
};
